import React, { useState } from 'react';
import Layout from '../components/layout/Layout';
import { useWallet } from '../context/WalletContext';
import { useUserData } from '../hooks/useUserData';
import HeldIncomeList from '../components/income/HeldIncomeList';
import RoyaltyCard from '../components/income/RoyaltyCard';
import IncomeBreakdown from '../components/dashboard/IncomeBreakdown';
import { POOL_TYPES } from '../utils/constants';
import { fmtUSDT } from '../utils/format';

const EarningsSummary = ({ income }) => {
  const inc = income || {};
  return (
    <div className="card">
      <div className="card-title">Earnings Summary</div>
      <div style={{ marginTop: 8 }}>
        <div className="card-sub">Total Income</div>
        <div className="card-value yellow">{fmtUSDT(inc.totalIncomeGross || 0)}</div>
        <div className="card-sub">USDT — counts toward 4× ceiling</div>
      </div>
      <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 12, lineHeight: 1.5 }}>
        Sponsor / Level / Booster income is sent directly to your wallet on every upgrade — no withdraw needed.
        Royalty pools and held income require manual claim below.
      </div>
    </div>
  );
};

const Income = () => {
  const { account } = useWallet();
  const [refreshKey, setRefreshKey] = useState(0);
  const user = useUserData(refreshKey);
  const refresh = () => setRefreshKey((k) => k + 1);

  return (
    <Layout dashboard>
      <div className="page-header">
        <div className="page-title">Income</div>
        <div className="page-subtitle">Direct-pay earnings, royalty pools, and held sponsor income.</div>
      </div>

      {!account ? (
        <div className="card" style={{ textAlign: 'center' }}>
          <div className="empty-title">Connect your wallet to view income</div>
        </div>
      ) : (
        <>
          <div className="grid grid-2">
            <EarningsSummary income={user.income} />
            <IncomeBreakdown income={user.income} />
          </div>

          <div className="section" style={{ marginTop: 24 }}>
            <div className="section-title">Royalty Pools</div>
            <div className="grid grid-3">
              <RoyaltyCard poolType={POOL_TYPES.ELITE}  user={user} onChanged={refresh} />
              <RoyaltyCard poolType={POOL_TYPES.PRO}    user={user} onChanged={refresh} />
              <RoyaltyCard poolType={POOL_TYPES.GLOBAL} user={user} onChanged={refresh} />
            </div>
          </div>

          <div className="section">
            <div className="section-title">Held Income</div>
            <HeldIncomeList held={user.heldIncomes} onChanged={refresh} />
          </div>
        </>
      )}
    </Layout>
  );
};

export default Income;
